import { render, staticRenderFns } from "./ImportSaleProduct.vue?vue&type=template&id=54613cd4"
import script from "./ImportSaleProduct.vue?vue&type=script&lang=js"
export * from "./ImportSaleProduct.vue?vue&type=script&lang=js"
import style0 from "./ImportSaleProduct.vue?vue&type=style&index=0&id=54613cd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports